import { render, staticRenderFns } from "./Improvements.vue?vue&type=template&id=48bc8472&scoped=true&"
import script from "./Improvements.vue?vue&type=script&lang=js&"
export * from "./Improvements.vue?vue&type=script&lang=js&"
import style0 from "./Improvements.vue?vue&type=style&index=0&id=48bc8472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bc8472",
  null
  
)

export default component.exports